import React from "react";
import "./PaymentStatusModal.css";
import close from "../../Assets/close.svg";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye } from "@fortawesome/free-solid-svg-icons";
import { faSquareCheck } from "@fortawesome/free-solid-svg-icons";
import { FaDownload } from "react-icons/fa";
import pdf from "../../Assets/PDF.svg";

const PaymentStatusModal = ({ onClose, onReject, onApprove }) => {
  const handleGoBack = () => {
    onClose();
  };

  const handleReject = () => {
    onClose();
    onReject();
  };

  const handleApprove = () => {
    onClose();
    onApprove();
  };

  return (
    <div className="modal-overlay">
      <div className="payment-modal-container">
        <button className="close-btn" onClick={onClose}>
          <img src={close} alt="" />
        </button>
        <h2>Payment Status</h2>
        <div className="invoice-details">
          <h2>Invoice To:</h2>
          <p>[Restaurant Name]</p>
          <p>[Address]</p>
          <p>[Contact Number]</p>
          <p>[Email]</p>
        </div>
        <div className="payment-breakdown">
          <h2>Payment Breakdown:</h2>
          <p><li> System Setup Fee: {"[Amount]"} </li></p>
          <p><li> Monthly Subscription (if any): {"[Amount]"}</li></p>
          <p><li> Customization (if applicable): {"[Amount]"}</li></p>
          <p><li>Total Payable: {"[Total Amount]"}</li></p>
        </div>
        <hr />
        <div className="payment-status">
          <div>
            <h2>Payment Method:</h2>
            <FontAwesomeIcon
              icon={faSquareCheck}
              style={{ color: "#37c51b" }}
            />{" "}
            <p className="paid">PAID</p>
          </div>
          <div>
            <h2>Date: </h2>
            <p>[Payment Date]</p>
          </div>
        </div>
        <div className="file-container">
          <div className="file-info">
            <div className="file-icon">
              <img src={pdf} alt="" />
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-start",
                marginLeft: "10px",
              }}>
              <span
                style={{
                  color: "#344054",
                  fontSize: "15px",
                  fontWeight: "500",
                }}>
                Invoice
              </span>
            </div>
          </div>
          <div className="file-actions">
            <FaDownload className="icon" style={{ color: "#F8951D" }} />
            <FontAwesomeIcon
              icon={faEye}
              className="icon"
              style={{ color: "#F8951D" }}
            />
          </div>
        </div>
        <div className="modal-actions">
          <button className="go-back" onClick={handleGoBack}>Go Back</button>
          <div style={{ display: "flex", gap: "10px" }}>
            <button className="reject" onClick={handleReject}>Reject</button>
            <button className="approve" onClick={handleApprove}>Approve</button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaymentStatusModal;
